export default __webpack_public_path__ + "static/media/email-white.298a5a33.svg";